import { createModelSchema, primitive } from 'serializr';

export class Session {
    id: number | null = null;

    accessed: number | null;

    created: number | null;

    current: boolean | null;

    type: 'login' | 'api' | 'site';

    expiry: number | null;

    path: string | null;

    token: string | null;
}

createModelSchema(Session, {
    id: primitive(),
    created: primitive(),
    accessed: primitive(),
    type: primitive(),
    expiry: primitive(),
    path: primitive(),
    token: primitive(),
    current: primitive()
});
